import Vue from 'vue';

import store from '@/store';
import router from '@/router';

import profiler from '@/plugins/profiler';
import essentia from '@/plugins/essentia';
import points from '@/plugins/points';
import geoIcons from '@/plugins/geoIcons';
import content from '@/plugins/content';
import dictionary from '@/plugins/dictionary';
import tools from '@/plugins/tools';
import gmaps from '@/plugins/gmaps';
import ym from '@/plugins/ym';

import faIcon from '@/icons';
import App from './App.vue';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;
// Vue.config.performance = true;

Vue.use(essentia, { store });
Vue.use(points, { store, dictionary });
Vue.use(content, { store });
Vue.use(ym, { store });
Vue.use(dictionary);
Vue.use(tools, { store, dictionary });
Vue.use(gmaps);
Vue.use(geoIcons);
Vue.use(profiler);

Vue.component('faIcon', faIcon);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
